import type { KeyboardEvent, Ref } from 'react'

import classNames from 'classnames'

interface InputProps {
  label: string
  placeholder?: string
  className?: string
  value?: string
  onChange?: (value: string) => void
  onKeyDown?: (event: KeyboardEvent<HTMLInputElement>) => void
  inputRef?: Ref<HTMLInputElement>
}

export default function Input({
  label,
  placeholder,
  className,
  value,
  onChange,
  onKeyDown,
  inputRef,
}: InputProps) {
  const labelClass = classNames('font-semibold', 'mb-4')
  const selectClass = classNames(
    'rounded-md',
    'p-4',
    'w-full',
    'border-grey-600',
    'focus:ring-2 focus:ring-blue-800 border-blue-800',
  )
  return (
    <div className={`flex flex-col ${className}`}>
      <span className={labelClass}>{label}</span>
      <input
        ref={inputRef}
        className={selectClass}
        type="number"
        placeholder={placeholder}
        value={value}
        onChange={e => onChange?.(e.target.value)}
        onKeyDown={onKeyDown}
      />
    </div>
  )
}
